import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { closeModal } from "../redux/features/modalSlice";
import { successToast, errorToast } from "../Utils/toast";
import { useDeleteItemMutation } from "../redux/services/CommonApi/deleteApi";
function DeleteModal({
  title,
  message,
  apiUrl,
  id,
}) {
  const dispatch = useDispatch();
  const [deleteItem] = useDeleteItemMutation();
  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    try {
      setLoading(true);
      const res = await deleteItem({
        url: apiUrl,
        id,
      }).unwrap();

      successToast(
        res?.message || "Deleted Successfully"
      );

      dispatch(closeModal());

    } catch (error) {

      errorToast(
        error?.data?.message ||
        "Delete Failed"
      );

    } finally {

      setLoading(false);

    }
  };

// DeleteModal.jsx

return (
  <>
    <div className="custom-modal-body text-center">

      <div className="model-custum">

        {/* ICON */}
        <div className="status-icon">
          <h1>🗑️</h1>
        </div>

        {/* TITLE */}
        <h3>
          {title}
        </h3>

        {/* MESSAGE */}
        <p className="delete-text">
          {message}
        </p>

      </div>

    </div>

    {/* BUTTONS */}
    <div className="modal-btn-group justify-content-center">

      <button
        className="cancel-btn"
        onClick={() => dispatch(closeModal())}
      >
        Cancel
      </button>

      <button
        className="delete-btn"
        onClick={handleDelete}
        disabled={loading}
      >
        {
          loading
            ? "Deleting..."
            : "Delete"
        }
      </button>

    </div>
  </>
);
}

export default DeleteModal;